<template>
  <button class="facet-selector">
    <span class="label-wrapper">
    <span class="label">{{ label }}</span>
    <span v-if="count > 0" class="selected-count">
      {{ count }}
      </span>
    </span>
    <span class="arrow-icon"></span>
  </button>
</template>

<script>
export default {
  name: 'FacetSelector',
  props: {
    label: {
      type: String,
      required: true
    },
    count: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style scoped>
.facet-selector {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 16px 0;
  border: none;
  border-bottom: 1px solid #323232;
  background: none;
  cursor: pointer;
  font-size: 16px;
  text-align: left;
  font-weight: 500;
  font-family: inherit;
}

.label-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.selected-count {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background-color: #2655ff;
  color: white;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 500;
  margin-top: 0px;
}

.arrow-icon {
  width: 24px;
  height: 24px;
  background-image: url("data:image/svg+xml,%3Csvg width='24' height='16' viewBox='0 0 24 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M19.4148 6.99968L14.0508 1.63568L15.4648 0.22168L23.2428 7.99968L15.4648 15.7777L14.0508 14.3637L19.4148 8.99968H0.75708V6.99968H19.4148Z' fill='%232655FF'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

</style> 